import { Paragraph2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './index.css';
import { IconAnalytics } from '../Icons/Analytics';

export interface IAnalyticsButton {
  onClick(event?: React.SyntheticEvent<HTMLDivElement>): void;
}

export const AnalyticsButton: React.SFC<IAnalyticsButton> = ({ onClick }) => (
  <div className={styles['container']} onClick={onClick} role="button">
    <IconAnalytics className={styles['icon']} />
    <div className={styles['button_text']}>
      <Paragraph2 fontWeight="bold">Доступна аналитика по объекту</Paragraph2>
      <Paragraph2 color="primary_100">Посмотреть отчёт</Paragraph2>
    </div>
  </div>
);

AnalyticsButton.displayName = 'AnalyticsButton';
